import React from 'react';
import { classNames } from '../helpers/functions';

export default ({ status = 'default', size = 'sm', className }) => {
	const DOT_COLOR = {
		default: 'text-gray-400',
		success: 'text-green-400',
		error: 'text-red-400',
		warning: 'text-yellow-400',
		info: 'text-blue-400',
	};

	const DOT_SIZE = {
		xxs: 'h-1 w-1',
		small: 'h-1.5 w-1.5',
		medium: 'h-2 w-2',
		large: 'h-2.5 w-2.5',
	};

	return (
		<svg
			className={classNames(
				'mr-1.5',
				DOT_COLOR[status] || DOT_COLOR.default,
				DOT_SIZE[size],
				className
			)}
			fill="currentColor"
			viewBox="0 0 8 8"
		>
			<circle cx={4} cy={4} r={3} />
		</svg>
	);
};
